import React from "react";
import {ActivityType, MemberActivitiesType, MemberAnswerType} from "../../../../typings/activity";
import './feedback-quiz.scss'
import {Redirect, useHistory} from "react-router-dom";
import dayjs from "dayjs";
import { Card, CardHeader, CardContent, CardTitle, CardFooter } from "../../../../components/UI/Card";
interface IQuiz {
	activity: ActivityType
}
const FeedbackQuiz: React.FC<IQuiz> = ({ activity}) => {
	const DisplayAnswer = (props: { memberAnswers : MemberAnswerType[] }) => {
		const questions = activity.questions;
		const memberAnswers = props.memberAnswers
		return <>
			{
				questions.map((q, index) => {
					const answer = memberAnswers[index]
					return <div className="flex w-full flex-col mb-3 rounded border relative" key={`q-${q.id}`}>
						<span className="absolute top-0 right-0 mt-3 mr-3 font-bold fs-7 bg-primary text-white py-1 px-2 rounded">{index + 1}</span>
						<div className="flex w-full p-3 border-b bg-gray-100"
						     dangerouslySetInnerHTML={{ __html: q?.text || '' }} />
						<div className="flex w-full p-3 bg-card">{ answer ?
							(
								answer.isAnswered ? `${answer.answer}${q.type === 'pg' ? `. ${q.options?.find(o => o.index === answer.answer)?.text}` : ''}`
								: '-'
							)
							: '-'
						}</div>
					</div>
				})
			}
		</>
	}
	if(activity?.memberActivities){
		const { score, feedback, scored_date, member_answer, created_at } = activity?.memberActivities
		const memberAnswer: MemberAnswerType[] = JSON.parse(member_answer as any)
		return (
      <>
        <div className="flex flex-col gap-2">
          <div className="w-full flex gap-3">
            <Card className="w-1/2">
              <CardHeader className="gradient-primary text-white rounded-t-lg p-3 text-center">
                <CardTitle className="text-sm">Nilai Anda</CardTitle>
              </CardHeader>
              <CardContent className="p-3">
                <div className="w-full flex flex-col items-center justify-center">
                  <span className="font-bold text-2xl">{score ?? "-"}</span>
                </div>
              </CardContent>
            </Card>
            <Card className="w-1/2">
              <CardHeader className="gradient-accent text-white rounded-t-lg p-3 text-center">
                <CardTitle className="text-sm">Umpan Balik</CardTitle>
              </CardHeader>
              <CardContent className="p-3 text-xs">
                {feedback ?? "-"}
              </CardContent>
            </Card>
          </div>
          <div className="w-full flex gap-3">
            <Card className="w-1/2">
              <CardHeader className="bg-accent text-white rounded-t-lg p-3 text-center">
                <CardTitle className="text-xs">Dikerjakan Tanggal</CardTitle>
              </CardHeader>
              <CardContent className="p-3 text-sm">
                {dayjs(created_at).format("LLL")}
              </CardContent>
            </Card>
            <Card className="w-1/2">
              <CardHeader className="bg-secondary text-white rounded-t-lg p-3 text-center">
                <CardTitle className="text-sm">Dinilai Tanggal</CardTitle>
              </CardHeader>
              <CardContent className="p-3 text-sm">
                {scored_date
                  ? dayjs(scored_date).format("LLL")
                  : "Menunggu Penilaian"}
              </CardContent>
            </Card>
          </div>
        </div>
        <h3 className={"font-bold text-start w-full my-3"}>Jawaban</h3>
        <DisplayAnswer memberAnswers={memberAnswer} />
      </>
    );
	}else{
		return <Redirect to={`/course/${activity?.course_id}`} />
	}
}
export default FeedbackQuiz
